<p-dialog [(visible)]="displayDialog" [modal]="true" [style]="{ width: '90vw', maxWidth: '1200px', minHeight: '550px' }"
  [draggable]="false" [resizable]="false" [closable]="true" styleClass="vendor-credits-dialog" (onHide)="cancel()">

  <ng-template pTemplate="header">
    <div class="flex justify-content-between align-items-center w-full">
      <span class="text-lg font-semibold">Apply Credits – Invoice {{ invoiceNo }}</span>
      <form [formGroup]="form">
        <div class="flex flex-column gap-1">
          <label class="font-semibold text-sm">Applied On Date <span class="text-red-500">*</span></label>
          <p-calendar formControlName="appliedOnDate" [showIcon]="true" dateFormat="dd/mm/yy" [showButtonBar]="true"
            [showClear]="false" appendTo="body" styleClass="w-32">
          </p-calendar>
        </div>
      </form>
    </div>
  </ng-template>

  <ng-template pTemplate="content">
    <div class="dialog-content p-fluid mt-0">
      <div class="table-wrapper">
        <p-table [value]="credits" [loading]="loading" styleClass="p-datatable-sm p-datatable-gridlines" [rows]="3"
          [paginator]="true" [rowsPerPageOptions]="[5,10,20]" paginatorDropdownAppendTo="body" [scrollable]="false"
          [tableStyle]="{'min-width': '100%'}">
          <ng-template pTemplate="header">
            <tr>
              <th style="min-width:200px">Transaction Details</th>
              <th style="min-width:150px">Amount & TDS</th>
              <th style="min-width:130px">Available</th>
              <th style="min-width:180px">Credits to Apply</th>
              <th style="min-width:150px">TDS Applied</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-credit>
            <tr [ngClass]="{'bg-primary-50': credit.creditsToApply > 0 || credit.tdsApplied > 0}">
              <td>
                <div class="flex flex-column gap-1">
                  <div class="font-bold text-primary text-overflow-ellipsis">
                    {{ credit.referenceNumber }} <span *ngIf="credit.description">- {{ credit.description }}</span>
                  </div>
                  <div class="text-sm text-500">{{ credit.date | date:'dd/MM/yyyy' }}</div>
                  <div class="text-sm text-500">{{ credit.transactionType }}</div>
                </div>
              </td>
              <td>
                <div class="font-semibold">₹{{ credit.amount | number:'1.2-2' }}</div>
                <div *ngIf="credit.tdsAmount > 0" class="text-sm text-500">TDS: ₹{{ credit.tdsAmount | number:'1.2-2' }}
                </div>
              </td>
              <td>
                <div class="font-bold text-lg">₹{{ credit.availableBalance | number:'1.2-2' }}</div>
                <a (click)="applyFullCredit(credit)" class="text-sm text-primary cursor-pointer">
                  <i class="pi pi-check-circle mr-1"></i>Pay in Full
                </a>
              </td>
              <td>
                <p-inputNumber [(ngModel)]="credit.creditsToApply" [min]="0" [max]="credit.availableBalance"
                  [maxFractionDigits]="2" [minFractionDigits]="2" (ngModelChange)="onCreditChange(credit)"
                  styleClass="w-full" [showButtons]="true" buttonLayout="horizontal">
                </p-inputNumber>
              </td>
              <td>
                <p-inputNumber *ngIf="credit.maxTdsApplicable > 0" [(ngModel)]="credit.tdsApplied" [min]="0"
                  [max]="getMaxTds(credit)" [maxFractionDigits]="2" [minFractionDigits]="2"
                  (ngModelChange)="onTdsChange(credit)" styleClass="w-full" [showButtons]="true"
                  buttonLayout="horizontal">
                </p-inputNumber>
                <span *ngIf="credit.maxTdsApplicable === 0" class="text-500">N/A</span>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="5" class="text-center text-red-500 font-semibold">No Transaction Details Available.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <div class="grid">
      <div class="col-12 md:col-6">
        <div class="flex flex-column gap-1">
          <div class="flex justify-content-between">
            <span class="font-semibold">Credits Applied:</span>
            <span class="text-lg">₹{{ appliedCredits | number:'1.2-2' }}</span>
          </div>
          <div class="flex justify-content-between">
            <span class="font-semibold">TDS Applied:</span>
            <span class="text-lg">₹{{ appliedTds | number:'1.2-2' }}</span>
          </div>
        </div>
      </div>
      <div class="col-12 md:col-6">
        <div class="flex flex-column gap-1 align-items-end">
          <div class="flex justify-content-between w-full">
            <span class="font-semibold">Original Invoice Amount:</span>
            <span class="text-lg">₹{{ billAmountOrginal | number:'1.2-2' }}</span>
          </div>
          <div class="flex justify-content-between w-full">
            <span class="font-semibold">Prior Paid Amount:</span>
            <span class="text-lg">₹{{ priorPaidAmount | number:'1.2-2' }}</span>
          </div>
          <div class="flex justify-content-between w-full">
            <span class="font-semibold">Total Amount Applied:</span>
            <span class="text-lg">₹{{ totalApplied | number:'1.2-2' }}</span>
          </div>
          <div class="flex justify-content-between w-full" style="border-top:1px solid #90caf9;padding-top:0.25rem;">
            <span class="font-bold text-md">Final Invoice Balance:</span>
            <span class="text-xl font-bold">₹{{ remainingBalance | number:'1.2-2' }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="flex justify-content-end gap-2 mt-2">
      <p-button label="Cancel" class="p-button-outlined ml-2" icon="pi pi-times" severity="danger" size="small"
        (click)="cancel()"></p-button>
      <button pButton label="Apply Credits" class="p-button-primary" [disabled]="!hasCreditsApplied || !form.valid"
        (click)="save()">
      </button>
    </div>
  </ng-template>
  <p-toast></p-toast>
</p-dialog>